<script>
export default {
	props: {
		slide: Object,
	},
}
</script>
<template>
	<div v-if="slide.slideType == 'image'" class="">
		<SafeLink :to="slide.url">
			<Media :src="slide.img" width="100%" cover />
		</SafeLink>
	</div>
	<div v-else class="d-flex justify-space-between align-center secondary pa-3">
		<div>
			<v-icon class="mx-3 secondary"> {{ slide.icon }}</v-icon>
			<span class="font-1 secondary">{{ slide.message }}</span>
		</div>
		<div v-if="slide.links && slide.links.length" class="pr-2 d-flex justify-end align-center">
			<SafeLink
				class="pl-2 mr-2 secondary"
				v-for="(link, i) in slide.links"
				:to="link.url"
				:key="i"
				style="border-left: 1px solid white"
			>
				<div v-if="!link.type || link.type === 'link'">
					<v-icon v-if="link.icon" :color="$vars.secondarytext">{{ link.icon }}</v-icon>
					<span v-if="link.text">{{ link.text }}</span>
				</div>
				<Button v-else height="25px" :color="link.btnBgColor">
					<span :style="`color: ${link.btnTextColor}`">{{ link.text }}</span>
				</Button>
			</SafeLink>
		</div>
	</div>
</template>

